import React, { useEffect } from 'react';
import withRouter from '@utils/wrappers/WithRouter';
import CrudPage from '@modules/cruds/CrudPage';
import NeedsManager from '@utils/NeedsManager';
import AddressForm from './AddressForm';
import * as yup from 'yup';
import Error404 from '@components/Errors/404';
import { defaultConfigComponent } from './AddressesTable';

const addressPageSchema = yup.object().shape({});

const AddressPage = props => {
  // Fetch needs
  useEffect(() => {
    const needs = [{ url: '/api/addressTypes', dataPath: 'addressTypes' }];
    new NeedsManager(props.data, needs).fetchNeeds();
  }, []);

  const itemId = props.transferPropsRoute.params.id;

  /*   const defaultValues = {
    entityType: props.data.getIn(['editaddress', 'data', 'entityType']),
    xTypeId: props.data.getIn(['editaddress', 'data', 'xTypeId']),
  }; */

  //console.log('defaultValues', defaultValues);
  //if (!defaultValues.xTypeId) return <Error404 />;

  return (
    <CrudPage
      key={itemId}
      configComponent={defaultConfigComponent}
      form={AddressForm}
      //defaultValues={defaultValues}
      validationSchema={addressPageSchema}
    />
  );
};
export default withRouter(AddressPage);
